<template>
    <div class="payment-landing">
        <div class="media-column">
            <div class="image-wrapper">
                <img src="@/assets/payment-landing-v3.png" alt="Landing visual" class="hero-image">
            </div>
        </div>

        <div class="content-column">
            <h1>
                Your provider ordered the GeneSight test for you.
            </h1>
            <h2>
                The GeneSight test benefits:
            </h2>

            <ul class="feature-list">
                <li class="feature-item">
                    <div class="icon-wrapper">
                        <img src="@/assets/fa-dna.png" alt="dna" class="list-icon">
                    </div>
                    <span class="text">Personalized genetic insights</span>
                </li>
                <li class="feature-item">
                    <div class="icon-wrapper">
                        <img src="@/assets/fa-bullseye.png" alt="bullseye" class="list-icon">
                    </div>
                    <span class="text">Classifies 60+ mental health medications</span>
                </li>
                <li class="feature-item">
                    <div class="icon-wrapper">
                        <img src="@/assets/fa-bolt.png" alt="bolt" class="list-icon">
                    </div>
                    <span class="text">May help reduce medication trial and error</span>
                </li>
            </ul>

            <p class="description">
                Completing your order takes just a few minutes. We'll walk you through your cost, available affordability options, and payment.
            </p>

            <button class="cta-button" @click="handleContinue">
                Let's get started
            </button>
        </div>
    </div>
</template>

<script>

export default {
    name: "PaymentLanding",
    mounted() {
        this.$store.dispatch("setShowStartupLoader", false);
    },
    methods: {
        handleContinue() {
            this.$store.dispatch("setPufIsLandingPageViewed", true);
            this.$router.push({ name: "Payment-Verify" });
        }
    }
};
</script>

<style lang="scss" scoped>
.payment-landing {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: 40px;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px;
}

.media-column {
    flex: 0 0 50%;
    display: flex;

    .image-wrapper {
        position: relative;
        width: 100%;
        overflow: hidden;

        .hero-image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center center;
            display: block;
        }

        /* Overlay Card */
        .quote-card {
            position: absolute;
            bottom: 20px;
            left: 20px;
            right: 20px;
            background-color: #ffffff;
            padding: 16px 20px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

            p {
                font-family: "Inter", "Lato", sans-serif;
                color: #000;
                font-size: var(--font-size-tl, 18px);
                font-style: normal;
                font-weight: 400;
                line-height: 156%;
                letter-spacing: -0.18px;
            }

            .quote-author {
                color: #000;
                font-family: "Inter", "Lato", sans-serif;
                font-size: var(--font-size-ts, 14px);
                font-style: normal;
                font-weight: 400;
                line-height: 143%;
                letter-spacing: -0.14px;
            }
        }
    }
}

/* Right Content Column */
.content-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 60px 0;

    h1 {
        font-family: "Inter", "Raleway", sans-serif;
        color: #000;
        font-size: var(--font-size-h2xl, 40px);
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.8px;
        max-width: 500px;
        margin-bottom: 32px;
    }

    h2 {
        color: var(--Color-base-black, #000);
        font-family: var(--font-family-Inter, Inter);
        font-size: var(--font-size-hs, 20px);
        font-style: normal;
        font-weight: 600;
        line-height: 150%; /* 30px */
        letter-spacing: -0.2px;
        margin-bottom: 16px;
    }

    .feature-list {
        list-style: none;
        padding: 0;
        margin: 0 0 24px 0;

        .feature-item {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            color: var(--Color-blue-bright-500, #0691EF);

            font-family: "Inter", "Lato", sans-serif;
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 156%;
            letter-spacing: -0.18px;

            .icon-wrapper {
                display: flex;
                width: 48px;
                height: 48px;
                justify-content: center;
                align-items: center;
                border-radius: 48px;
                background: var(--Color-blue-bright-25, #F6FBFF);
                margin-right: 27px;

                img {
                    height: auto;
                    width: 20px;
                }
            }
        }
    }

    .description {
        font-family: "Inter", "Lato", sans-serif;
        font-size: 0.95rem;
        line-height: 1.6;
        color: #666666;
        margin-bottom: 32px;
    }

    .cta-button {
        font-family: "Inter", "Lato", sans-serif;
        align-self: flex-start;
        padding: 14px 28px;
        font-size: 1.25em;
        color: #ffffff;
        background-color: #0092E1;
        border: none;
        border-radius: 54px;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: #0052a3;
        }
    }
}

@media (max-width: 1075px) {
    .payment-landing {
        flex-direction: column-reverse;
        gap: 32px;
        padding: 16px;
    }

    .media-column {
        flex: 1 1 auto;
        width: 100%;

        .image-wrapper {

            .hero-image {
                object-position: center center;
            }

            .quote-card {
                max-width: 400px;
            }
        }
    }

    .content-column {
        padding: 60px 20px 10px;
        
        h1 {
            max-width: 100%; 
            font-size: var(--font-size-hxl, 32px);
        }

        .cta-button {
            margin-left: auto;
            margin-right: auto;
        }

        .feature-list {
            display: flex;
            flex-direction: row;
            gap: 24px;

            .feature-item {
                flex: 1;
                flex-direction: column;
                align-items: center;
                text-align: center;
                font-size: 16px;
                line-height: 140%;

                .icon-wrapper {
                    width: 56px;
                    height: 56px;
                    border-radius: 56px;
                    margin-right: 0;
                    margin-bottom: 12px;

                    img {
                        width: 24px;
                    }
                }

                .text {
                    max-width: 180px;
                }
            }
        }
    }
}

@media (max-width: 767px) {
    .media-column {
        display: none;
    }

    .content-column .feature-list {
        display: block;
    }

    .content-column .feature-list .feature-item {
        flex-direction: row;
    }

    .content-column .feature-list .feature-item .icon-wrapper {
        width: 48px;
        height: 48px;
        border-radius: 48px;
        margin-bottom: 0;
        margin-right: 20px;
    }

    .content-column .feature-list .feature-item .text {
        max-width: 100%;
    }
}

@include sm() {
    .content-column h1 {
        font-size: 26px;
    }

    .content-column .feature-list .feature-item {
        font-size: 16px;
    }
}

@media (max-width: 400px) {
    .content-column .feature-list .feature-item {
        font-size: 15px;
    }
}
</style>
